var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"hint"}},[_c('button',{staticClass:"btn-speaker",class:{
      disabled: _vm.playHint || _vm.isProcessing || _vm.disabledClass,
      pickup: _vm.pickup,
    },attrs:{"type":"button","disabled":_vm.disabled || _vm.playHint},on:{"click":_vm.doHint}},[(!_vm.complete && _vm.showHintHand)?_c('div',{staticClass:"suggest"}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }